/*
 * <cart-discount> — in-drawer discount code field (WS3 Phase 2).
 * Shopify has no official pre-checkout AJAX discount API, so "Apply" uses the
 * reliable redirect: /discount/{CODE}?redirect={path}. Shopify applies the code
 * to the session and returns to the page; we re-open the drawer and surface
 * basic feedback by comparing the cart-level discount count before/after.
 */
class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.button = this.querySelector('.cart-discount__apply');
    this.msg = this.querySelector('.cart-discount__msg');

    if (this.button) this.button.addEventListener('click', this.apply.bind(this));
    if (this.input) {
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.apply();
        }
      });
    }

    this.checkReturn();
  }

  apply() {
    if (!this.input) return;
    const code = (this.input.value || '').trim();
    if (!code) {
      this.input.focus();
      return;
    }
    try {
      sessionStorage.setItem('kzCartDiscReopen', '1');
      sessionStorage.setItem('kzCartDiscBefore', this.getAttribute('data-discount-count') || '0');
    } catch (e) {
      /* sessionStorage unavailable — feedback degrades, apply still works */
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = `${root}discount/${encodeURIComponent(code)}?redirect=${window.location.pathname}`;
  }

  checkReturn() {
    let flag;
    try {
      flag = sessionStorage.getItem('kzCartDiscReopen');
    } catch (e) {
      return;
    }
    if (flag !== '1') return;

    let before = 0;
    try {
      sessionStorage.removeItem('kzCartDiscReopen');
      before = parseInt(sessionStorage.getItem('kzCartDiscBefore') || '0', 10);
      sessionStorage.removeItem('kzCartDiscBefore');
    } catch (e) {
      /* ignore */
    }

    const now = parseInt(this.getAttribute('data-discount-count') || '0', 10);
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      setTimeout(() => drawer.open(), 100);
    }

    if (this.msg) {
      if (now > before) {
        this.msg.textContent = (document.documentElement.lang || '').toLowerCase().startsWith('es') ? 'Descuento aplicado.' : 'Discount applied.';
        this.msg.className = 'cart-discount__msg cart-discount__msg--ok';
      } else {
        this.msg.textContent = (document.documentElement.lang || '').toLowerCase().startsWith('es') ? 'No pudimos aplicar ese código. Revísalo e inténtalo de nuevo.' : "We couldn't apply that code — check it and try again.";
        this.msg.className = 'cart-discount__msg cart-discount__msg--err';
      }
      this.msg.hidden = false;
    }
  }
}

customElements.define('cart-discount', CartDiscount);
